import React, { ReactNode } from 'react';
import styled, { css } from 'styled-components';
import colors from 'src/integration/styles/colors';
import fonts from 'src/integration/styles/fonts';

type StyleType = 'primary' | 'secondary' | 'link' | 'loader' | 'colored' | 'outlined' | undefined;

interface ComponentProps extends Component {
  children: ReactNode;
  styleType?: StyleType;
  onClick?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}

const Root = styled.button<{
  $styleType: StyleType;
  disabled?: boolean;
}>`
    ${({ $styleType = 'primary', disabled }) => css`
    font-family: ${fonts.fontFamily.body};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    line-height: 100%;
    text-decoration: none;
    padding: 12px 28px;
    border-radius: 50px;
    pointer-events: ${disabled ? 'none' : 'auto'};

    ${$styleType === 'primary' &&
    css`
      color: ${colors.primaryWhite};
      background-color: ${disabled ? colors.grey2 : colors.primaryNewCar};
      border: 1px solid  ${disabled ? colors.grey2 : colors.primaryNewCar};
      text-transform: uppercase;

      &:hover {
        opacity: 0.8;
      }
    `}

    ${$styleType === 'secondary' &&
    css`
      color: ${colors.primaryWhite};
      background-color: ${colors.primaryYankeesBlue};
      border: 1px solid ${colors.primaryYankeesBlue};
      text-transform: uppercase;
        
      &:hover {
        opacity: 0.8;
      }
    `}

    ${$styleType === 'link' &&
    css`
      color: ${colors.primaryLink};
      background: none;
      padding: 0;
      border: none;
      font-size: 14px;
      font-weight: 400;
      line-height: 140%;

      &:hover {
        opacity: 0.8;
      }
    `}
  `}
`;

const Button = ({ children, styleType = 'primary', onClick, disabled, className, isLoading }: ComponentProps) => {
  return (
    <Root className={className} type={'button'} $styleType={styleType} disabled={disabled} onClick={onClick}>
      {isLoading ? <div>Loading..</div> : children}
    </Root>
  );
};

export default Button;
